import { Modal } from "@4uhub/lib4uhub";
import { memo } from "react";
import { WhatsappNameForm } from "./WhatsappNameForm";

export const WhatsappNameModal = memo(
  ({ open, closeHandler }: { open: boolean; closeHandler: () => void }) => {
    return (
      <>
        <Modal onClose={closeHandler} open={open}>
          <WhatsappNameForm onClose={closeHandler}></WhatsappNameForm>
        </Modal>
      </>
    );
  }
);
